import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Tabs,
  Tab,
} from '@material-ui/core';
import {getStoreStatisticsApi, getStoreProductsApi, getStoreBrandsApi, getSMBannersAPI, getFutureAssignedTasks} from 'api/index';
import Dashboard from './Dashboard/Dashboard';
import WelcomeScreen from './Welcome/WelcomeScreen';
import HomepageSlider from './Slider/HomepageSlider';


export default function Home() {
  const dispatch = useDispatch();
  const { profile } = useSelector((state: IReduxState) => state.user);
  const permissions = profile?.config?.permissions || {};
  const userStore = profile.stores?.[0];
  const isStoreLive = userStore?.isLive;
  const [tabIndex, setTabIndex] = useState(isStoreLive ? 1 : 0);

  useEffect(() => {
    setTabIndex(isStoreLive ? 1 : 0);
  }, [isStoreLive]);

  useEffect(() => {
    getStoreProductsApi({dispatch});
    getStoreStatisticsApi({dispatch});
    getStoreBrandsApi({dispatch});
    getSMBannersAPI({dispatch});
    getFutureAssignedTasks({dispatch});
  }, []);

  const handleChangeTab = (e, value) => {
    setTabIndex(value);
  };

  if (!userStore) {
    return null;
  }

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      {permissions?.SMBanner &&
      <div className="mx-10 mt-10">
        <h4>What&apos;s new at DermPRO</h4>
        <HomepageSlider />
      </div>}
      <Tabs
        value={tabIndex}
        textColor="primary"
        indicatorColor="primary"
        aria-label="secondary tabs"
        className="mb-8"
        onChange={handleChangeTab}
      >
        {!isStoreLive &&
        <Tab
          label={<div className="flex items-center">Home</div>}
          value={0}
          className="capitalize font-bold flex items-center px-4"
        />}
        <Tab
          label={<div className="flex items-center">Dashboard</div>}
          value={1}
          className="capitalize font-bold flex items-center px-4"
        />
      </Tabs>
      {tabIndex === 0 && <WelcomeScreen />}
      {tabIndex === 1 && <Dashboard />}
    </div>
  );
}
